/*
    Create By Chenchen 2015-10-19
    */
'use strict';
angular.module('manageCfg.roleManageMent.userManageMentaddUser', []).
controller('userManageMentaddUserController', ['$scope', '$q', '$stateParams', '$http', '$timeout', 'trsHttpService', '$modal', '$state', 'modalDialog', 'trsspliceString', 'trsTransferService', "globleParamsSet", "userManageMentService", function($scope, $q, $stateParams, $http, $timeout, trsHttpService, $modal, $state, modalDialog, trsspliceString, trsTransferService, globleParamsSet, userManageMentService) {
    /*
    初始化参数
    */
    initStatus();
    $scope.$on("roleData", function(event, roleData) {
        if (roleData.ROLEID === "2") { //everyOne用户不允许添加用户
            $state.go("manageconfig.rolemanage");
            return;
        }
        $scope.roleData = roleData;
        $scope.params.RoleId = roleData.ROLEID;
        initStatus();
    });
    //获取用户列表结束
    //增加了用户，重新刷新列表开始
    $scope.$on("addUser", function(event, data) {
        requestData();
    });
    //增加了用户，重新刷新列表结束

    //添加用户按钮开始
    $scope.addUser = function() {
        trsTransferService.getUser(function(data) {
            var params = {
                "UserIds": trsspliceString.spliceString(data, "ID", ","),
                "RoleId": $scope.roleData.ROLEID,
                "serviceid": "mlf_extrole",
                "methodname": "addUser"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                modalDialog.alertType("添加用户成功", "", "success", false, function() {
                    requestData();
                });
            });
        });
    };
    //添加用户按钮结束
    /**
     * [tenantincluded description] 选中项中是否包含了租户管理员
     * @return {[type]} [description]
     */
    function tenantincluded(userList) {
        var flag = false;
        for (var i = 0; i < userList.length; i++) {
            var item = userList[i];
            if (item.AUTOTENANTADMIN === "true") {
                flag = true;
                break;
            }
        }
        return flag;
    }
    //批量删除用户按钮开始
    $scope.deleteUser = function(userList) {
        var flag = tenantincluded(userList);
        if (flag) {
            modalDialog.alertType("租户管理员不允许被移除", "请确认是否选择了租户管理员", "warning", "confirm");
            return;
        }
        modalDialog.confirmModal('删除', '确定移除?', function() {
            var UserIds = trsspliceString.spliceString(userList,
                'USERID', ',');
            $scope.selectedArray = [];
            var params = {
                "serviceid": "mlf_extrole",
                "methodname": "removeUser",
                "RoleId": $scope.roleData.ROLEID,
                "UserIds": UserIds
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, "get").then(function(data) {
                requestData();
            });
        });
    };
    //批量删除用户结束
    //删除用户开始
    //单个删除用户
    $scope.deleteItem = function(item) {
        $scope.deleteUser([item]);
    };
    //移动用户
    $scope.moveUser = function(userList) {
        var flag = tenantincluded(userList);
        if (flag) {
            modalDialog.alertType("租户管理员不允许被移除", "请确认是否选择了租户管理员", "warning", "confirm");
            return;
        }
        trsTransferService.getPowerRole("选择要移动的角色", !!$scope.groupObj ? $scope.groupObj.GROUPID : "", [], function(data) {
            var params = {
                "serviceid": "mlf_extuser",
                "methodname": "moveUsersToRoles",
                "UserIds": trsspliceString.spliceString(userList, 'USERID', ','),
                "RoleIds": data.ROLEID,
                "CurRoleId": $scope.roleData.ROLEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                modalDialog.alertType("移动角色成功", "", "success", false, function() {
                    userList = [];
                    requestData();
                });
            });
        });
    };
    /**
     * [showUserDetail description]查看用户详细信息
     */
    $scope.showUserDetail = function(item) {
        userManageMentService.showUserDetail("用户详细信息", item.USERID, function(data) {});
    };
    //全选
    $scope.selectAll = function() {
        $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : [].concat($scope.items);
    };
    //单选
    $scope.selectDoc = function(item) {
        if ($scope.selectedArray.indexOf(item) < 0) {
            $scope.selectedArray.push(item);
        } else {
            $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        }
    };
    //跳转到下一页
    $scope.pageChanged = function() {
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };
    //跳转到
    $scope.jumpToPage = function() {
        if ($scope.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.params.CurrPage = $scope.copyCurrPage;
        requestData();
    };
    //初始化状态
    function initStatus() {
        watchRoleData().then(function() {
            $scope.selectedArray = [];
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": globleParamsSet.setResourceCenterPageSize,
                "PAGECOUNT": 1,
                "ITEMCOUNT": 0,
            };
            $scope.copyCurrPage = 1;
            $scope.params = {
                "serviceid": "mlf_extrole",
                "methodname": "queryUsers",
                "PageSize": $scope.page.PAGESIZE,
                "RoleId": $scope.roleData.ROLEID,
                "CurrPage": $scope.page.CURRPAGE
            };
            requestData();
        });
    }
    /**
     * [watchRoleData description] 监控确保有正确的roleData
     * @return {[type]} [description]
     */
    function watchRoleData() {
        var deffer = $q.defer();
        if ($scope.roleData) {
            deffer.resolve();
        } else {
            var watcher = $scope.$watch("roleData", function(newV, oldV) {
                if (newV) {
                    deffer.resolve();
                    watcher();
                }
            });
        }
        return deffer.promise;
    }
    //初始化数据
    function requestData(callback) {
        trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, "get").then(function(data) {
            if (angular.isFunction(callback)) {
                callback(data);
            } else {
                $scope.items = data.DATA;
                $scope.copyItems = data.DATA;
                !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = "0";
                $scope.searchUserName = "";
                $scope.$broadcast('pageChange', $scope.page);
            }
        });
    }
    //可选分页数
    $scope.selectPageNum = function() {
        $scope.params.PageSize = $scope.page.PAGESIZE;
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.copyCurrPage = 1;
        requestData();
    };
    /**
     * [根据用户名检索]
     * @param  {[obj]}时间对象
     * @return {[type]}null
     */
    $scope.fullTextSearch = function(ev) {
        if (angular.isDefined(ev) && ev.keyCode == 13 || angular.isUndefined(ev)) {
            var params = {
                serviceid: "mlf_extuser",
                methodname: "searchUsersOfRole",
                SearchName: $scope.searchUserName,
                RoleId: $scope.roleData.ROLEID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.items = data;
                //后端未返回分页参数后的处理
                $scope.page.CURRPAGE = 1;
                $scope.page.ITEMCOUNT = data.length;
                $scope.page.PAGECOUNT = data.length == 0 ? 1 : data.length % $scope.page.PAGESIZE;
            });
        }
    }
}]);